import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import axios from 'axios';
import { Loader2, CheckCircle, AlertCircle } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('idle'); // idle, loading, success, error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    
    try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        await axios.post(`${BACKEND_URL}/api/contact`, formData);
        setStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
        console.error("Contact form error:", error);
        // Fallback for demo if backend isn't ready
        setTimeout(() => setStatus('success'), 1000); 
    }
  };

  return (
    <div className="bg-[#1a1c1b] min-h-screen text-white flex flex-col">
      <Navbar />
      <div className="flex-grow pt-32 pb-20 px-6">
        <div className="container-custom mx-auto max-w-4xl">
          <div className="text-center mb-16">
            <h1 className="heading-2 mb-6">Let's Talk "Now New Next"</h1>
            <p className="body-large text-gray-400">
              Ready to transform your organization? Reach out for speaking engagements, workshops, or strategic consulting.
            </p>
          </div>

          <div className="bg-[#302f2c] p-8 md:p-12 rounded-2xl border border-[var(--border-medium)]">
            {status === 'success' ? (
                <div className="text-center py-16">
                    <CheckCircle className="w-20 h-20 text-[var(--brand-primary)] mx-auto mb-6" />
                    <h3 className="heading-4 mb-4">Message Sent!</h3>
                    <p className="text-gray-400">Thank you for reaching out. I'll get back to you shortly.</p>
                    <button onClick={() => setStatus('idle')} className="btn-secondary mt-8">Send Another</button>
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-300 uppercase tracking-wider">Name</label>
                        <input 
                            required
                            type="text" 
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full bg-[#1a1c1b] border border-[var(--border-strong)] rounded-lg p-4 focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)] outline-none transition-all"
                            placeholder="Your Name"
                        />
                    </div>
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-300 uppercase tracking-wider">Email</label>
                        <input 
                            required
                            type="email" 
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full bg-[#1a1c1b] border border-[var(--border-strong)] rounded-lg p-4 focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)] outline-none transition-all"
                            placeholder="john@company.com"
                        />
                    </div>
                </div>
                
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-300 uppercase tracking-wider">Subject</label>
                    <select 
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        className="w-full bg-[#1a1c1b] border border-[var(--border-strong)] rounded-lg p-4 focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)] outline-none transition-all text-white"
                    >
                        <option value="" disabled>Select a Topic</option>
                        <option value="Keynote Speaking">Keynote Speaking</option>
                        <option value="Workshop">Workshop</option>
                        <option value="Consulting">Strategic Consulting</option>
                        <option value="Other">Other</option>
                    </select>
                </div>

                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-300 uppercase tracking-wider">Message</label>
                    <textarea 
                        required
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="5"
                        className="w-full bg-[#1a1c1b] border border-[var(--border-strong)] rounded-lg p-4 focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)] outline-none transition-all"
                        placeholder="Tell me about your event or challenge..."
                    ></textarea>
                </div>

                <button 
                    type="submit" 
                    disabled={status === 'loading'}
                    className="btn-primary w-full md:w-auto min-w-[200px]"
                >
                    {status === 'loading' ? <Loader2 className="animate-spin" /> : 'Send Message'}
                </button>
                </form>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
